export const NEUTRAL_ICON_URL = '/assets/neutral-icon.svg?v=1';
export const NEUTRAL_THEME_COLOR = '#334155';

const ICON_RELS = ['icon', 'apple-touch-icon'];

const swapIconLink = (rel: string): (() => void) | undefined => {
  const original = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!original) return undefined;

  // Safari ignores an href change on an existing icon link, so a fresh element is inserted instead.
  const neutral = document.createElement('link');
  neutral.rel = rel;
  neutral.href = NEUTRAL_ICON_URL;
  original.replaceWith(neutral);

  return () => neutral.replaceWith(original);
};

export const applyNeutralHeadBranding = (): (() => void) => {
  const restoreIcons = ICON_RELS.map(swapIconLink);
  const themeColor = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  const previousColor = themeColor?.getAttribute('content');

  themeColor?.setAttribute('content', NEUTRAL_THEME_COLOR);

  return () => {
    restoreIcons.forEach((restore) => restore?.());
    if (themeColor && previousColor != null) themeColor.setAttribute('content', previousColor);
  };
};
